export const EMAIL_ORDER_INVOICES_SEGMENT = "email-order-invoices";

/** Removes the order-keyed email invoices dialog suffix from a pathname. */
export const stripEmailOrderInvoicesDialog = (pathname: string): string => {
  const normalizedPath = pathname.replace(/\/+$/, "");
  const segmentSuffix = `/${EMAIL_ORDER_INVOICES_SEGMENT}/`;
  const segmentStart = normalizedPath.lastIndexOf(segmentSuffix);
  if (segmentStart < 0) return pathname;

  const orderKey = normalizedPath.slice(segmentStart + segmentSuffix.length);
  if (!orderKey || orderKey.includes("/")) return pathname;

  return normalizedPath.slice(0, segmentStart) || "/";
};
